import React from 'react';
import clinaddis from '../assets/clinaddis.png';
import clin2 from '../assets/clin2.png';
import clinaddis5 from '../assets/clinaddis5.png';
import clinaddis1 from '../assets/clinaddis1.png';
import './Events.css';
import mohSession from '../assets/clinadis9.png';
import artMedicine2 from '../assets/clinadis10.png';

const Events = () => {
  const events = [
    {
      id: 1,
      title: "Storytelling in Medicine",
      date: "June 21, 2025",
      description: "A heartfelt evening with 60+ diverse guests, from medical practitioners to social scientists and even high-school dreamers. Through open-mic storytelling, participants shared their personal journeys in medicine. It was a night of vulnerability, laughter, and true human connection.",
      image: clinaddis,
      location: "Blue Space" // First imported image
    },
    {
      id: 2,
      title: "Coffee & Medicine: A Creative Wellness Gathering",
      date: "July 19, 2025",
      description: "With 40 attendees, this intimate session at Chaka Coffee blended reflection exercises, table conversations, and artistic expressions like poetry. A safe and warm space where people opened up about their personal and professional lives, with wellness at the heart of it all.",
      image: clin2, // Second imported image
      partners: ["Chaka Coffee"],
      location: "Chaka Coffee"
    },
    {
      id: 3,
      title: "Hands & Hearts: A Healing Partnership",
      date: "September 2, 2025",
      description: "Hosted with the Children's Heart Foundation Ethiopia, this event welcomed 80+ participants into a world of hands-on workshops: CPR, pump machine operation, anesthesia demonstrations, and more. Renowned cardiac professionals inspired the crowd, while a hospital tour grounded everyone in the realities of healthcare. Powered by Blue Health Ethiopia, Jember Coffee, and Cardiac Center Ethiopia, it was a moving day of skill, compassion, and collaboration.",
      image: clinaddis5, // Third imported image
      partners: ["Children's Heart Foundation Ethiopia", "Blue Health Ethiopia", "Jember Coffee", "Cardiac Center Ethiopia"],
      location:  "Children Hearts Fund of Ethiopia"
    },
    {
      id: 4,
      title: "Art & Medicine: A Reflective Endeavor",
      date: "August 9, 2025",
      description: "Our largest event yet, drawing 250+ attendees to Hilton Hotel and Kikundi Gallery. From Dr. Atakilit's powerful talk on the intersection of medicine and art, to live painting sessions, coffee & tea tastings, and vibrant networking — this event bridged the worlds of healthcare, creativity, and community. Supported by ArtDesignDrift, Tona Coffee, and Se_ne Tea, it became a true celebration of diversity, innovation, and expression.",
      image: clinaddis1, // Fourth imported image
      location: "Hilton Hotel Addis Ababa",
      partners: ["Kikundi Gallery"]
    },
    {
      id: 5,
      title: "Art & Medicine | Part II: Seeing, Knowing, Healing",
      date: "December 27, 2025",
      description: "Hosted at Kikundi Gallery, Hilton Addis Ababa, Art & Medicine | Part II was an intimate, discussion-driven session exploring the relationship between artistic practice and medical thinking. Bringing together clinicians, students, and creatives, the program centered on thoughtful dialogue, reflective art, and human-centered perspectives on healthcare—continuing ClinAddis' commitment to curating meaningful interdisciplinary conversations.",
      image: artMedicine2, // New image for Art & Medicine Part II
      location: "Hilton Hotel Addis Ababa",
      partners: ["Kikundi Art Gallery"]
    },
    {
      id: 6,
      title: "Digital Health & AI Learning Sessions: Practical Innovation in Healthcare",
      date: "January 26, 2026",
      description: "ClinAddis hosts Digital Health and AI learning sessions at the Ministry of Health in collaboration with system actors to create practical and informed conversations around technology in healthcare. The sessions bring together health professionals, students, innovators, and policymakers to explore how digital tools and AI are already being used in real healthcare settings in Ethiopia. Rather than focusing on hype, the discussions center on real experiences, challenges, ethics, quality, and equity. A key message throughout the session is that digital literacy strengthens clinical practice and health system performance without replacing professional judgment. Through these engagements, ClinAddis supports responsible innovation and builds bridges between policy, practice, and emerging health technologies.",
      image: mohSession, // New image for MOH session
      location: "Ministry of Health",
      partners: ["MoH"]
    }
  ];

  return (
    <div className="events-page">
      {/* Page Title */}
      <section className="events-hero">
        <div className="container">
          <h1>Our Events</h1>
          <p className="page-subtitle">
            Connecting the medical community through meaningful gatherings, workshops, and shared experiences.
          </p>
        </div>
      </section>

      {/* Events List with Alternating Layout */}
      <section className="section">
        <div className="container">
          <div className="events-list">
            {events.map((event, index) => (
              <div 
                key={event.id} 
                className={`event-item ${index % 2 === 0 ? 'image-right' : 'image-left'}`}
              >
                <div className="event-content-wrapper">
                  {/* Text Content - Always on left */}
                  <div className="event-text-content">
                    {/* Main Heading */}
                    <h2 className="event-main-title">{event.title}</h2>
                    
                    {/* Date */}
                    <div className="event-meta">
                      <span className="event-date-display">{event.date}</span>
                    </div>
                    
                    {/* Description Paragraphs */}
                    <div className="event-description-text">
                      <p>{event.description}</p>
                      
                      {/* Additional info for MOH session */}
                      {event.additionalInfo && (
                        <p className="additional-paragraph">{event.additionalInfo}</p>
                      )}
                    </div>
                    
                    {/* Additional Info */}
                    {event.location && (
                      <div className="event-additional-info">
                        <p><strong>Location:</strong> {event.location}</p>
                      </div>
                    )}
                    
                    {event.partners && (
                      <div className="event-additional-info">
                        <p><strong>Partners:</strong> {event.partners.join(", ")}</p>
                      </div>
                    )}
                  </div>

                  {/* Event Image - Alternating sides */}
                  <div className="event-image-container">
                    <img 
                      src={event.image} 
                      alt={event.title}
                      className="event-main-image"
                    />
                  </div>
                </div>
                
                {/* Separator line between events */}
                {index < events.length - 1 && <hr className="event-separator" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="section section-alt">
        <div className="container">
          <div className="footer-cta">
            <h3>Want to Join Our Next Event?</h3>
            <p>Stay updated with our upcoming gatherings and community activities.</p>
            <a href="/join" className="btn btn-primary">Join the movement</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;